module.exports = __webpack_public_path__ + "static/media/mixer-alt.a210e341.svg";